import { get_token } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import { client_domain } from "@/main.js";

export default {
  name: "SponsoredAds",
   components: {
    HomeNavBar,
    StickyNav
  },
  computed: {

  },
   inject: ['client_features'],
  data() {
    return ({
      ads: [
        {
          image: require("@/assets/images/ads/app_icon.png"),
          title: "Level up your knowledge powered by FCSA",
          url: "fsca.aicampus.co.za",
          download_links: {
            apple: "https://apps.apple.com/za/app/bazingabiz/id6740227859",
            google: "https://play.google.com/store/apps/details?id=com.fsca.bazingabiz",
            huawei: "https://appgallery.cloud.huawei.com/ag/n/app/C113301173",
            web: "fsca.aicampus.co.za"
          }
        },
                {
          image: require("@/assets/images/ads/business partners.svg"),
          title: "Business Partners.",
          url: "businesspartners.co.za",
        },
                        {
          image: require("@/assets/images/ads/trainerz.svg"),
          title: "Lawyerz/Trainerz.",
          url: "training.lawyerz.co.za"
        },
        {
          image: require("@/assets/images/ads/complyon.svg"),
          title: "Keep Your Employees and Suppliers Compliant, Easily.",
          url: "complyon.ai",
        },
        {
          image: require("@/assets/images/ads/x-verdict.svg"),
          title: "Manage your tickets and cases with clarity.",
          url: "x-verdict.ai",
        },
        {
          image: require("@/assets/images/ads/engangenet.svg"),
          title: "Build Your Own Community",
          url: "engagenet.ai",
        },
        {
          image: require("@/assets/images/ads/proba_workflows_2.svg"),
          title: "Less Paperwork, More Flow",
          url: "probaworkflows.com",
        },

        {
          image: require("@/assets/images/ads/orcaa.svg"),
          title: "Hire. Train. Grow",
          url: "orcaa.ai",
        },

        {
          image: require("@/assets/images/ads/proba_analytics.svg"),
          title: "Turn data into decisions",
          url: "probaanalytics.io",
        },


      ],
      token_exists: false,
      visibleCount: 20,
      visible_domain: false,
      showAll: false,
      userPlatform: "web",
    });
  },
  computed: {
    filtered_ads() {
      let baseAds = this.showAll ? this.ads : this.ads.slice(0, this.visibleCount);

      if (client_domain.includes("cbo")) {
        // On cbo → show everything
        return baseAds;
      } else {
        // On all other domains → filter out cbo-only ads
        return baseAds.filter(ad =>
          ad.title !== "Business Partners." && ad.title !== "Lawyerz/Trainerz."
        );
      }
    },

    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
  },
  mounted() {
    this.token_exists = get_token();

      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
        this.userPlatform = "google";
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.userPlatform = "apple";
      } else if (/HUAWEI|HONOR/i.test(userAgent)) {
        this.userPlatform = "huawei";
      } else {
        this.userPlatform = "web";
      }
  },
  methods: {
    openAd(ad) {
      // Get the link based on platform or fallback
      let link = ad.download_links
        ? ad.download_links[this.userPlatform] || ad.download_links.web || ad.url
        : ad.url;

      // Ensure the link has a protocol (https://) if missing
      if (!/^https?:\/\//i.test(link)) {
        link = `https://${link}`;
      }
      // Open the link in a new tab
      window.open(link, "_blank");
    }
  },
};